import {
  SET_AREAS,
  SET_PROVINCES,
  SET_CITIES,
  SET_DISTRICTS,
  SET_VILLAGES,
  SET_BRANCHES,
  SET_BRANCHES_BY_ID,
  SET_BRANCHES_BY_AREAID
} from "@/stores/constants";
import {
  getAreas,
  getProvinces,
  getCities,
  getDistricts,
  getVillages,
  getBranches,
  getBranchesById,
  getBranchesByAreaId,
} from "@/services/area";

export default {
  namespaced: true,
  state: {
    areas: [],
    provinces: [],
    cities: [],
    districts: [],
    villages: [],
    branches: [],
    branchesById: [],
    branchesByAreaId: []
  },
  getters: {
    getAreas: (state) =>
      state.areas.map(item => ({
        id: item.areaId,
        name: item.namaArea,
        regionId: item.regionId,
        regionName: item.namaRegion,
        original: item,
      })),
    getProvinces: state => state.provinces,
    getCities: state => state.cities,
    getDistricts: state => state.districts,
    getVillages: state => state.villages,
    getBranches: state => state.branches,
    getBranchesById: state => state.branchesById,
    getBranchesByAreaId: state => state.branchesByAreaId,
  },
  mutations: {
    SET_AREAS(state, payload) {
      state.areas = payload;
    },
    [SET_PROVINCES](state, provinces) {
      state.provinces = provinces;
    },
    [SET_CITIES](state, cities) {
      state.cities = cities;
    },
    [SET_DISTRICTS](state, districts) {
      state.districts = districts;
    },
    [SET_VILLAGES](state, villages) {
      state.villages = villages;
    },
    SET_BRANCHES_BY_AREAID(state, branches) {
      state.branchesByAreaId = branches;
    },
    [SET_BRANCHES_BY_ID](state, branchesById) {
      state.branchesById = branchesById;
    },
    [SET_BRANCHES_BY_AREAID](state, branchesByAreaId) {
      state.branchesByAreaId = branchesByAreaId;
    }
  },
  actions: {
    async fetchAreas({ commit }) {
      const data = await getAreas(); // ⬅️ LANGSUNG ARRAY
      commit('SET_AREAS', data);
    },
    async fetchProvinces({ commit }, params = {}) {
      const result = await getProvinces(params);
      const { data } = result.data;
      commit(SET_PROVINCES, data);
    },
    async fetchCities({ commit }, params = {}) {
      const result = await getCities(params);
      const { data } = result.data;
      commit(SET_CITIES, data);
    },
    async fetchDistricts({ commit }, params = {}) {
      const result = await getDistricts(params);
      const { data } = result.data;
      commit(SET_DISTRICTS, data);
    },
    async fetchVillages({ commit }, params = {}) {
      const result = await getVillages(params);
      const { data } = result.data;
      commit(SET_VILLAGES, data);
    },
    async fetchBranches({ commit }, params = {}) {
      const result = await getBranches(params);
      const { data } = result.data;
      commit(SET_BRANCHES, data);
    },
    async fetchBranchesById({ commit }, id) {
      const result = await getBranchesById(id);
      const { data } = result.data;
      commit(SET_BRANCHES_BY_ID, data);
    },
    async fetchBranchesByAreaId({ commit }, { areaId, objGroupId }) {
      const data = await getBranchesByAreaId({ areaId, objGroupId });

      commit("SET_BRANCHES_BY_AREAID", data);
    }
  }
};
